const ianaTimezones = {
    "ianaVersion": "2022a",
    "fullVersionId": "TZDB: 2022a (mapping: $Revision$)",
    "zones": [
        {
            "id": "Africa/Abidjan",
            "aliases": [
                "Africa/Accra",
                "Africa/Bamako",
                "Africa/Banjul",
                "Africa/Conakry",
                "Africa/Dakar",
                "Africa/Freetown",
                "Africa/Lome",
                "Africa/Nouakchott",
                "Africa/Ouagadougou",
                "Africa/Timbuktu",
                "Atlantic/St_Helena"
            ],
            "location": {
                "countryCode": "CI",
                "countryName": "C\u00F4te d\u0027Ivoire",
                "comment": "",
                "latitude": 5.316666666666666,
                "longitude": -4.033333333333333
            },
            "offsets": [
                "\u002B00"
            ]
        },
        {
            "id": "Africa/Algiers",
            "aliases": [],
            "location": {
                "countryCode": "DZ",
                "countryName": "Algeria",
                "comment": "",
                "latitude": 36.78333333333333,
                "longitude": 3.05
            },
            "offsets": [
                "\u002B01"
            ]
        },
        {
            "id": "Africa/Bissau",
            "aliases": [],
            "location": {
                "countryCode": "GW",
                "countryName": "Guinea-Bissau",
                "comment": "",
                "latitude": 11.85,
                "longitude": -15.583333333333334
            },
            "offsets": [
                "\u002B00"
            ]
        },
        {
            "id": "Africa/Cairo",
            "aliases": [
                "Egypt"
            ],
            "location": {
                "countryCode": "EG",
                "countryName": "Egypt",
                "comment": "",
                "latitude": 30.05,
                "longitude": 31.25
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Africa/Casablanca",
            "aliases": [],
            "location": {
                "countryCode": "MA",
                "countryName": "Morocco",
                "comment": "",
                "latitude": 33.65,
                "longitude": -7.583333333333333
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Africa/Ceuta",
            "aliases": [],
            "location": {
                "countryCode": "ES",
                "countryName": "Spain",
                "comment": "Ceuta, Melilla",
                "latitude": 35.88333333333333,
                "longitude": -5.316666666666666
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Africa/El_Aaiun",
            "aliases": [],
            "location": {
                "countryCode": "EH",
                "countryName": "Western Sahara",
                "comment": "",
                "latitude": 27.15,
                "longitude": -13.2
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Africa/Johannesburg",
            "aliases": [
                "Africa/Maseru",
                "Africa/Mbabane"
            ],
            "location": {
                "countryCode": "ZA",
                "countryName": "South Africa",
                "comment": "",
                "latitude": -26.25,
                "longitude": 28
            },
            "offsets": [
                "\u002B02"
            ]
        },
        {
            "id": "Africa/Juba",
            "aliases": [],
            "location": {
                "countryCode": "SS",
                "countryName": "South Sudan",
                "comment": "",
                "latitude": 4.85,
                "longitude": 31.616666666666667
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Africa/Khartoum",
            "aliases": [],
            "location": {
                "countryCode": "SD",
                "countryName": "Sudan",
                "comment": "",
                "latitude": 15.6,
                "longitude": 32.53333333333333
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Africa/Lagos",
            "aliases": [
                "Africa/Bangui",
                "Africa/Brazzaville",
                "Africa/Douala",
                "Africa/Kinshasa",
                "Africa/Libreville",
                "Africa/Luanda",
                "Africa/Malabo",
                "Africa/Niamey",
                "Africa/Porto-Novo"
            ],
            "location": {
                "countryCode": "NG",
                "countryName": "Nigeria",
                "comment": "",
                "latitude": 6.45,
                "longitude": 3.4
            },
            "offsets": [
                "\u002B01"
            ]
        },
        {
            "id": "Africa/Maputo",
            "aliases": [
                "Africa/Blantyre",
                "Africa/Bujumbura",
                "Africa/Gaborone",
                "Africa/Harare",
                "Africa/Kigali",
                "Africa/Lubumbashi",
                "Africa/Lusaka"
            ],
            "location": {
                "countryCode": "MZ",
                "countryName": "Mozambique",
                "comment": "",
                "latitude": -25.966666666666665,
                "longitude": 32.583333333333336
            },
            "offsets": [
                "\u002B02"
            ]
        },
        {
            "id": "Africa/Monrovia",
            "aliases": [],
            "location": {
                "countryCode": "LR",
                "countryName": "Liberia",
                "comment": "",
                "latitude": 6.3,
                "longitude": -10.783333333333333
            },
            "offsets": [
                "\u002B00"
            ]
        },
        {
            "id": "Africa/Nairobi",
            "aliases": [
                "Africa/Addis_Ababa",
                "Africa/Asmara",
                "Africa/Asmera",
                "Africa/Dar_es_Salaam",
                "Africa/Djibouti",
                "Africa/Kampala",
                "Africa/Mogadishu",
                "Indian/Antananarivo",
                "Indian/Comoro",
                "Indian/Mayotte"
            ],
            "location": {
                "countryCode": "KE",
                "countryName": "Kenya",
                "comment": "",
                "latitude": -1.2833333333333334,
                "longitude": 36.81666666666667
            },
            "offsets": [
                "\u002B03"
            ]
        },
        {
            "id": "Africa/Ndjamena",
            "aliases": [],
            "location": {
                "countryCode": "TD",
                "countryName": "Chad",
                "comment": "",
                "latitude": 12.116666666666667,
                "longitude": 15.05
            },
            "offsets": [
                "\u002B01"
            ]
        },
        {
            "id": "Africa/Sao_Tome",
            "aliases": [],
            "location": {
                "countryCode": "ST",
                "countryName": "Sao Tome \u0026 Principe",
                "comment": "",
                "latitude": 0.3333333333333333,
                "longitude": 6.733333333333333
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Africa/Tripoli",
            "aliases": [
                "Libya"
            ],
            "location": {
                "countryCode": "LY",
                "countryName": "Libya",
                "comment": "",
                "latitude": 32.9,
                "longitude": 13.183333333333334
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Africa/Tunis",
            "aliases": [],
            "location": {
                "countryCode": "TN",
                "countryName": "Tunisia",
                "comment": "",
                "latitude": 36.8,
                "longitude": 10.183333333333334
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Africa/Windhoek",
            "aliases": [],
            "location": {
                "countryCode": "NA",
                "countryName": "Namibia",
                "comment": "",
                "latitude": -22.566666666666666,
                "longitude": 17.1
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "America/Adak",
            "aliases": [
                "America/Atka",
                "US/Aleutian"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Aleutian Islands",
                "latitude": 51.88,
                "longitude": -176.65805555555556
            },
            "offsets": [
                "-10",
                "-09"
            ]
        },
        {
            "id": "America/Anchorage",
            "aliases": [
                "US/Alaska"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Alaska (most areas)",
                "latitude": 61.21805555555556,
                "longitude": -149.90027777777777
            },
            "offsets": [
                "-09",
                "-08"
            ]
        },
        {
            "id": "America/Araguaina",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Tocantins",
                "latitude": -7.2,
                "longitude": -48.2
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Buenos_Aires",
            "aliases": [
                "America/Buenos_Aires"
            ],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Buenos Aires (BA, CF)",
                "latitude": -34.6,
                "longitude": -58.45
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Catamarca",
            "aliases": [
                "America/Argentina/ComodRivadavia",
                "America/Catamarca"
            ],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Catamarca (CT); Chubut (CH)",
                "latitude": -28.466666666666665,
                "longitude": -65.78333333333333
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Cordoba",
            "aliases": [
                "America/Cordoba",
                "America/Rosario"
            ],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Argentina (most areas: CB, CC, CN, ER, FM, MN, SE, SF)",
                "latitude": -31.4,
                "longitude": -64.18333333333334
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Jujuy",
            "aliases": [
                "America/Jujuy"
            ],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Jujuy (JY)",
                "latitude": -24.183333333333334,
                "longitude": -65.3
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/La_Rioja",
            "aliases": [],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "La Rioja (LR)",
                "latitude": -29.433333333333334,
                "longitude": -66.85
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Mendoza",
            "aliases": [
                "America/Mendoza"
            ],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Mendoza (MZ)",
                "latitude": -32.88333333333333,
                "longitude": -68.81666666666666
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Rio_Gallegos",
            "aliases": [],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Santa Cruz (SC)",
                "latitude": -51.63333333333333,
                "longitude": -69.21666666666667
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Salta",
            "aliases": [],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Salta (SA, LP, NQ, RN)",
                "latitude": -24.783333333333335,
                "longitude": -65.41666666666667
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/San_Juan",
            "aliases": [],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "San Juan (SJ)",
                "latitude": -31.533333333333335,
                "longitude": -68.51666666666667
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/San_Luis",
            "aliases": [],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "San Luis (SL)",
                "latitude": -33.31666666666667,
                "longitude": -66.35
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Tucuman",
            "aliases": [],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Tucuman (TM)",
                "latitude": -26.816666666666666,
                "longitude": -65.21666666666667
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Argentina/Ushuaia",
            "aliases": [],
            "location": {
                "countryCode": "AR",
                "countryName": "Argentina",
                "comment": "Tierra del Fuego (TF)",
                "latitude": -54.8,
                "longitude": -68.3
            },
            "offsets": [
                "-04",
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Asuncion",
            "aliases": [],
            "location": {
                "countryCode": "PY",
                "countryName": "Paraguay",
                "comment": "",
                "latitude": -25.266666666666666,
                "longitude": -57.666666666666664
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Bahia",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Bahia",
                "latitude": -12.983333333333333,
                "longitude": -38.516666666666666
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Bahia_Banderas",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Central Time - Bahia de Banderas",
                "latitude": 20.8,
                "longitude": -105.25
            },
            "offsets": [
                "-07",
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Barbados",
            "aliases": [],
            "location": {
                "countryCode": "BB",
                "countryName": "Barbados",
                "comment": "",
                "latitude": 13.1,
                "longitude": -59.61666666666667
            },
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "America/Belem",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Para (east); Amapa",
                "latitude": -1.45,
                "longitude": -48.483333333333334
            },
            "offsets": [
                "-03"
            ]
        },
        {
            "id": "America/Belize",
            "aliases": [],
            "location": {
                "countryCode": "BZ",
                "countryName": "Belize",
                "comment": "",
                "latitude": 17.5,
                "longitude": -88.2
            },
            "offsets": [
                "-06"
            ]
        },
        {
            "id": "America/Boa_Vista",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Roraima",
                "latitude": 2.816666666666667,
                "longitude": -60.666666666666664
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Bogota",
            "aliases": [],
            "location": {
                "countryCode": "CO",
                "countryName": "Colombia",
                "comment": "",
                "latitude": 4.6,
                "longitude": -74.08333333333333
            },
            "offsets": [
                "-05"
            ]
        },
        {
            "id": "America/Boise",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Mountain - ID (south); OR (east)",
                "latitude": 43.61361111111111,
                "longitude": -116.2025
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "America/Cambridge_Bay",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Mountain - NU (west)",
                "latitude": 69.1138888888889,
                "longitude": -105.05277777777778
            },
            "offsets": [
                "-07",
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Campo_Grande",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Mato Grosso do Sul",
                "latitude": -20.45,
                "longitude": -54.61666666666667
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Cancun",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Eastern Standard Time - Quintana Roo",
                "latitude": 21.083333333333332,
                "longitude": -86.76666666666667
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Caracas",
            "aliases": [],
            "location": {
                "countryCode": "VE",
                "countryName": "Venezuela",
                "comment": "",
                "latitude": 10.5,
                "longitude": -66.93333333333334
            },
            "offsets": [
                "-04:30",
                "-04"
            ]
        },
        {
            "id": "America/Cayenne",
            "aliases": [],
            "location": {
                "countryCode": "GF",
                "countryName": "French Guiana",
                "comment": "",
                "latitude": 4.933333333333334,
                "longitude": -52.333333333333336
            },
            "offsets": [
                "-03"
            ]
        },
        {
            "id": "America/Chicago",
            "aliases": [
                "US/Central"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Central (most areas)",
                "latitude": 41.85,
                "longitude": -87.65
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Chihuahua",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Mountain Time - Chihuahua (most areas)",
                "latitude": 28.633333333333333,
                "longitude": -106.08333333333333
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "America/Costa_Rica",
            "aliases": [],
            "location": {
                "countryCode": "CR",
                "countryName": "Costa Rica",
                "comment": "",
                "latitude": 9.933333333333334,
                "longitude": -84.08333333333333
            },
            "offsets": [
                "-06"
            ]
        },
        {
            "id": "America/Cuiaba",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Mato Grosso",
                "latitude": -15.583333333333334,
                "longitude": -56.083333333333336
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Danmarkshavn",
            "aliases": [],
            "location": {
                "countryCode": "GL",
                "countryName": "Greenland",
                "comment": "National Park (east coast)",
                "latitude": 76.76666666666667,
                "longitude": -18.666666666666668
            },
            "offsets": [
                "\u002B00"
            ]
        },
        {
            "id": "America/Dawson",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "MST - Yukon (west)",
                "latitude": 64.06666666666666,
                "longitude": -139.41666666666666
            },
            "offsets": [
                "-08",
                "-07"
            ]
        },
        {
            "id": "America/Dawson_Creek",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "MST - BC (Dawson Cr, Ft St John)",
                "latitude": 59.766666666666666,
                "longitude": -120.23333333333333
            },
            "offsets": [
                "-07"
            ]
        },
        {
            "id": "America/Denver",
            "aliases": [
                "America/Shiprock",
                "Navajo",
                "US/Mountain"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Mountain (most areas)",
                "latitude": 39.73916666666667,
                "longitude": -104.98416666666667
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "America/Detroit",
            "aliases": [
                "US/Michigan"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - MI (most areas)",
                "latitude": 42.33138888888889,
                "longitude": -83.04583333333333
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Edmonton",
            "aliases": [
                "Canada/Mountain"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Mountain - AB; BC (E); SK (W)",
                "latitude": 53.55,
                "longitude": -113.46666666666667
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "America/Eirunepe",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Amazonas (west)",
                "latitude": -6.666666666666667,
                "longitude": -69.86666666666666
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/El_Salvador",
            "aliases": [],
            "location": {
                "countryCode": "SV",
                "countryName": "El Salvador",
                "comment": "",
                "latitude": 13.7,
                "longitude": -89.2
            },
            "offsets": [
                "-06"
            ]
        },
        {
            "id": "America/Fort_Nelson",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "MST - BC (Ft Nelson)",
                "latitude": 58.8,
                "longitude": -122.7
            },
            "offsets": [
                "-08",
                "-07"
            ]
        },
        {
            "id": "America/Fortaleza",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Brazil (northeast: MA, PI, CE, RN, PB)",
                "latitude": -3.716666666666667,
                "longitude": -38.5
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Glace_Bay",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Atlantic - NS (Cape Breton)",
                "latitude": 46.2,
                "longitude": -59.95
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Goose_Bay",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Atlantic - Labrador (most areas)",
                "latitude": 53.333333333333336,
                "longitude": -60.416666666666664
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Grand_Turk",
            "aliases": [],
            "location": {
                "countryCode": "TC",
                "countryName": "Turks \u0026 Caicos Is",
                "comment": "",
                "latitude": 21.466666666666665,
                "longitude": -71.13333333333334
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Guatemala",
            "aliases": [],
            "location": {
                "countryCode": "GT",
                "countryName": "Guatemala",
                "comment": "",
                "latitude": 14.633333333333333,
                "longitude": -90.51666666666667
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Guayaquil",
            "aliases": [],
            "location": {
                "countryCode": "EC",
                "countryName": "Ecuador",
                "comment": "Ecuador (mainland)",
                "latitude": -2.1666666666666665,
                "longitude": -79.83333333333333
            },
            "offsets": [
                "-05"
            ]
        },
        {
            "id": "America/Guyana",
            "aliases": [],
            "location": {
                "countryCode": "GY",
                "countryName": "Guyana",
                "comment": "",
                "latitude": 6.8,
                "longitude": -58.166666666666664
            },
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "America/Halifax",
            "aliases": [
                "Canada/Atlantic"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Atlantic - NS (most areas); PE",
                "latitude": 44.65,
                "longitude": -63.6
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Havana",
            "aliases": [
                "Cuba"
            ],
            "location": {
                "countryCode": "CU",
                "countryName": "Cuba",
                "comment": "",
                "latitude": 23.133333333333333,
                "longitude": -82.36666666666666
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Hermosillo",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Mountain Standard Time - Sonora",
                "latitude": 29.066666666666666,
                "longitude": -110.96666666666667
            },
            "offsets": [
                "-07"
            ]
        },
        {
            "id": "America/Indiana/Indianapolis",
            "aliases": [
                "America/Fort_Wayne",
                "America/Indianapolis",
                "US/East-Indiana"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - IN (most areas)",
                "latitude": 39.76833333333333,
                "longitude": -86.15805555555555
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Indiana/Knox",
            "aliases": [
                "America/Knox_IN",
                "US/Indiana-Starke"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Central - IN (Starke)",
                "latitude": 41.295833333333334,
                "longitude": -86.625
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Indiana/Marengo",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - IN (Crawford)",
                "latitude": 38.37555555555556,
                "longitude": -86.34472222222222
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Indiana/Petersburg",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - IN (Pike)",
                "latitude": 38.49194444444444,
                "longitude": -87.2786111111111
            },
            "offsets": [
                "-06",
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Indiana/Tell_City",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Central - IN (Perry)",
                "latitude": 37.95305555555556,
                "longitude": -86.76138888888889
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Indiana/Vevay",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - IN (Switzerland)",
                "latitude": 38.74777777777778,
                "longitude": -85.06722222222223
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Indiana/Vincennes",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - IN (Da, Du, K, Mn)",
                "latitude": 38.67722222222222,
                "longitude": -87.5286111111111
            },
            "offsets": [
                "-06",
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Indiana/Winamac",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - IN (Pulaski)",
                "latitude": 41.05138888888889,
                "longitude": -86.60305555555556
            },
            "offsets": [
                "-06",
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Inuvik",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Mountain - NT (west)",
                "latitude": 68.34972222222223,
                "longitude": -133.71666666666667
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "America/Iqaluit",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Eastern - NU (most east areas)",
                "latitude": 63.733333333333334,
                "longitude": -68.46666666666667
            },
            "offsets": [
                "-06",
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Jamaica",
            "aliases": [
                "Jamaica"
            ],
            "location": {
                "countryCode": "JM",
                "countryName": "Jamaica",
                "comment": "",
                "latitude": 17.968055555555555,
                "longitude": -76.79333333333334
            },
            "offsets": [
                "-05"
            ]
        },
        {
            "id": "America/Juneau",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Alaska - Juneau area",
                "latitude": 58.301944444444445,
                "longitude": -134.41972222222222
            },
            "offsets": [
                "-09",
                "-08"
            ]
        },
        {
            "id": "America/Kentucky/Louisville",
            "aliases": [
                "America/Louisville"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - KY (Louisville area)",
                "latitude": 38.25416666666667,
                "longitude": -85.75944444444444
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Kentucky/Monticello",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern - KY (Wayne)",
                "latitude": 36.82972222222222,
                "longitude": -84.84916666666666
            },
            "offsets": [
                "-06",
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/La_Paz",
            "aliases": [],
            "location": {
                "countryCode": "BO",
                "countryName": "Bolivia",
                "comment": "",
                "latitude": -16.5,
                "longitude": -68.15
            },
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "America/Lima",
            "aliases": [],
            "location": {
                "countryCode": "PE",
                "countryName": "Peru",
                "comment": "",
                "latitude": -12.05,
                "longitude": -77.05
            },
            "offsets": [
                "-05"
            ]
        },
        {
            "id": "America/Los_Angeles",
            "aliases": [
                "US/Pacific"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Pacific",
                "latitude": 34.05222222222222,
                "longitude": -118.24277777777777
            },
            "offsets": [
                "-08",
                "-07"
            ]
        },
        {
            "id": "America/Maceio",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Alagoas, Sergipe",
                "latitude": -9.666666666666666,
                "longitude": -35.71666666666667
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Managua",
            "aliases": [],
            "location": {
                "countryCode": "NI",
                "countryName": "Nicaragua",
                "comment": "",
                "latitude": 12.15,
                "longitude": -86.28333333333333
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Manaus",
            "aliases": [
                "Brazil/West"
            ],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Amazonas (east)",
                "latitude": -3.1333333333333333,
                "longitude": -60.016666666666666
            },
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "America/Martinique",
            "aliases": [],
            "location": {
                "countryCode": "MQ",
                "countryName": "Martinique",
                "comment": "",
                "latitude": 14.6,
                "longitude": -61.083333333333336
            },
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "America/Matamoros",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Central Time US - Coahuila, Nuevo Leon, Tamaulipas (US border)",
                "latitude": 25.833333333333332,
                "longitude": -97.5
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Mazatlan",
            "aliases": [
                "Mexico/BajaSur"
            ],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Mountain Time - Baja California Sur, Nayarit, Sinaloa",
                "latitude": 23.216666666666665,
                "longitude": -106.41666666666667
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "America/Menominee",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Central - MI (Wisconsin border)",
                "latitude": 45.10777777777778,
                "longitude": -87.61416666666666
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Merida",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Central Time - Campeche, Yucatan",
                "latitude": 20.966666666666665,
                "longitude": -89.61666666666666
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Metlakatla",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Alaska - Annette Island",
                "latitude": 55.12694444444445,
                "longitude": -131.57638888888889
            },
            "offsets": [
                "-09",
                "-08"
            ]
        },
        {
            "id": "America/Mexico_City",
            "aliases": [
                "Mexico/General"
            ],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Central Time",
                "latitude": 19.4,
                "longitude": -99.15
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Miquelon",
            "aliases": [],
            "location": {
                "countryCode": "PM",
                "countryName": "St Pierre \u0026 Miquelon",
                "comment": "",
                "latitude": 47.05,
                "longitude": -56.333333333333336
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Moncton",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Atlantic - New Brunswick",
                "latitude": 46.1,
                "longitude": -64.78333333333333
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Monterrey",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Central Time - Durango; Coahuila, Nuevo Leon, Tamaulipas (most areas)",
                "latitude": 25.666666666666668,
                "longitude": -100.31666666666666
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Montevideo",
            "aliases": [],
            "location": {
                "countryCode": "UY",
                "countryName": "Uruguay",
                "comment": "",
                "latitude": -34.909166666666664,
                "longitude": -56.2125
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/New_York",
            "aliases": [
                "US/Eastern"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Eastern (most areas)",
                "latitude": 40.714166666666664,
                "longitude": -74.00638888888889
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Nipigon",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Eastern - ON, QC (no DST 1967-73)",
                "latitude": 49.016666666666666,
                "longitude": -88.26666666666667
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Nome",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Alaska (west)",
                "latitude": 64.50111111111111,
                "longitude": -165.4063888888889
            },
            "offsets": [
                "-09",
                "-08"
            ]
        },
        {
            "id": "America/Noronha",
            "aliases": [
                "Brazil/DeNoronha"
            ],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Atlantic islands",
                "latitude": -3.85,
                "longitude": -32.416666666666664
            },
            "offsets": [
                "-02",
                "-01"
            ]
        },
        {
            "id": "America/North_Dakota/Beulah",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Central - ND (Mercer)",
                "latitude": 47.26416666666667,
                "longitude": -101.77777777777777
            },
            "offsets": [
                "-07",
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/North_Dakota/Center",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Central - ND (Oliver)",
                "latitude": 47.11638888888889,
                "longitude": -101.29916666666666
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/North_Dakota/New_Salem",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Central - ND (Morton rural)",
                "latitude": 46.845,
                "longitude": -101.41083333333333
            },
            "offsets": [
                "-07",
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Nuuk",
            "aliases": [
                "America/Godthab"
            ],
            "location": {
                "countryCode": "GL",
                "countryName": "Greenland",
                "comment": "Greenland (most areas)",
                "latitude": 64.18333333333334,
                "longitude": -51.733333333333334
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Ojinaga",
            "aliases": [],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Mountain Time US - Chihuahua (US border)",
                "latitude": 29.566666666666666,
                "longitude": -104.41666666666667
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "America/Panama",
            "aliases": [
                "America/Atikokan",
                "America/Cayman",
                "America/Coral_Harbour"
            ],
            "location": {
                "countryCode": "PA",
                "countryName": "Panama",
                "comment": "",
                "latitude": 8.966666666666667,
                "longitude": -79.53333333333333
            },
            "offsets": [
                "-05"
            ]
        },
        {
            "id": "America/Pangnirtung",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Eastern - NU (Pangnirtung)",
                "latitude": 66.13333333333334,
                "longitude": -65.73333333333333
            },
            "offsets": [
                "-06",
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Paramaribo",
            "aliases": [],
            "location": {
                "countryCode": "SR",
                "countryName": "Suriname",
                "comment": "",
                "latitude": 5.833333333333333,
                "longitude": -55.166666666666664
            },
            "offsets": [
                "-03"
            ]
        },
        {
            "id": "America/Phoenix",
            "aliases": [
                "America/Creston",
                "US/Arizona"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "MST - Arizona (except Navajo)",
                "latitude": 33.44833333333333,
                "longitude": -112.07333333333334
            },
            "offsets": [
                "-07"
            ]
        },
        {
            "id": "America/Port-au-Prince",
            "aliases": [],
            "location": {
                "countryCode": "HT",
                "countryName": "Haiti",
                "comment": "",
                "latitude": 18.533333333333335,
                "longitude": -72.33333333333333
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Porto_Velho",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Rondonia",
                "latitude": -8.766666666666667,
                "longitude": -63.9
            },
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "America/Puerto_Rico",
            "aliases": [
                "America/Anguilla",
                "America/Antigua",
                "America/Aruba",
                "America/Blanc-Sablon",
                "America/Curacao",
                "America/Dominica",
                "America/Grenada",
                "America/Guadeloupe",
                "America/Kralendijk",
                "America/Lower_Princes",
                "America/Marigot",
                "America/Montserrat",
                "America/Port_of_Spain",
                "America/St_Barthelemy",
                "America/St_Kitts",
                "America/St_Lucia",
                "America/St_Thomas",
                "America/St_Vincent",
                "America/Tortola",
                "America/Virgin"
            ],
            "location": {
                "countryCode": "PR",
                "countryName": "Puerto Rico",
                "comment": "",
                "latitude": 18.468333333333334,
                "longitude": -66.1061111111111
            },
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "America/Punta_Arenas",
            "aliases": [],
            "location": {
                "countryCode": "CL",
                "countryName": "Chile",
                "comment": "Region of Magallanes",
                "latitude": -53.15,
                "longitude": -70.91666666666667
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Rainy_River",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Central - ON (Rainy R, Ft Frances)",
                "latitude": 48.71666666666667,
                "longitude": -94.56666666666666
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Rankin_Inlet",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Central - NU (central)",
                "latitude": 62.81666666666667,
                "longitude": -92.08305555555556
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Recife",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Pernambuco",
                "latitude": -8.05,
                "longitude": -34.9
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Regina",
            "aliases": [
                "Canada/Saskatchewan"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "CST - SK (most areas)",
                "latitude": 50.4,
                "longitude": -104.65
            },
            "offsets": [
                "-06"
            ]
        },
        {
            "id": "America/Resolute",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Central - NU (Resolute)",
                "latitude": 74.69555555555556,
                "longitude": -94.82916666666667
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Rio_Branco",
            "aliases": [
                "America/Porto_Acre",
                "Brazil/Acre"
            ],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Acre",
                "latitude": -9.966666666666667,
                "longitude": -67.8
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Santarem",
            "aliases": [],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Para (west)",
                "latitude": -2.433333333333333,
                "longitude": -54.86666666666667
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Santiago",
            "aliases": [
                "Chile/Continental"
            ],
            "location": {
                "countryCode": "CL",
                "countryName": "Chile",
                "comment": "Chile (most areas)",
                "latitude": -33.45,
                "longitude": -70.66666666666667
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Santo_Domingo",
            "aliases": [],
            "location": {
                "countryCode": "DO",
                "countryName": "Dominican Republic",
                "comment": "",
                "latitude": 18.466666666666665,
                "longitude": -69.9
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Sao_Paulo",
            "aliases": [
                "Brazil/East"
            ],
            "location": {
                "countryCode": "BR",
                "countryName": "Brazil",
                "comment": "Brazil (southeast: GO, DF, MG, ES, RJ, SP, PR, SC, RS)",
                "latitude": -23.533333333333335,
                "longitude": -46.61666666666667
            },
            "offsets": [
                "-03",
                "-02"
            ]
        },
        {
            "id": "America/Scoresbysund",
            "aliases": [],
            "location": {
                "countryCode": "GL",
                "countryName": "Greenland",
                "comment": "Scoresbysund/Ittoqqortoormiit",
                "latitude": 70.48333333333333,
                "longitude": -21.966666666666665
            },
            "offsets": [
                "-01",
                "\u002B00"
            ]
        },
        {
            "id": "America/Sitka",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Alaska - Sitka area",
                "latitude": 57.17638888888889,
                "longitude": -135.30194444444444
            },
            "offsets": [
                "-09",
                "-08"
            ]
        },
        {
            "id": "America/St_Johns",
            "aliases": [
                "Canada/Newfoundland"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Newfoundland; Labrador (southeast)",
                "latitude": 47.56666666666667,
                "longitude": -52.71666666666667
            },
            "offsets": [
                "-03:30",
                "-02:30"
            ]
        },
        {
            "id": "America/Swift_Current",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "CST - SK (midwest)",
                "latitude": 50.28333333333333,
                "longitude": -107.83333333333333
            },
            "offsets": [
                "-06"
            ]
        },
        {
            "id": "America/Tegucigalpa",
            "aliases": [],
            "location": {
                "countryCode": "HN",
                "countryName": "Honduras",
                "comment": "",
                "latitude": 14.1,
                "longitude": -87.21666666666667
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Thule",
            "aliases": [],
            "location": {
                "countryCode": "GL",
                "countryName": "Greenland",
                "comment": "Thule/Pituffik",
                "latitude": 76.56666666666666,
                "longitude": -68.78333333333333
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "America/Thunder_Bay",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Eastern - ON (Thunder Bay)",
                "latitude": 48.38333333333333,
                "longitude": -89.25
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Tijuana",
            "aliases": [
                "America/Ensenada",
                "America/Santa_Isabel",
                "Mexico/BajaNorte"
            ],
            "location": {
                "countryCode": "MX",
                "countryName": "Mexico",
                "comment": "Pacific Time US - Baja California",
                "latitude": 32.53333333333333,
                "longitude": -117.01666666666667
            },
            "offsets": [
                "-08",
                "-07"
            ]
        },
        {
            "id": "America/Toronto",
            "aliases": [
                "America/Montreal",
                "America/Nassau",
                "Canada/Eastern"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Eastern - ON, QC (most areas)",
                "latitude": 43.65,
                "longitude": -79.38333333333334
            },
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "America/Vancouver",
            "aliases": [
                "Canada/Pacific"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Pacific - BC (most areas)",
                "latitude": 49.266666666666666,
                "longitude": -123.11666666666666
            },
            "offsets": [
                "-08",
                "-07"
            ]
        },
        {
            "id": "America/Whitehorse",
            "aliases": [
                "Canada/Yukon"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "MST - Yukon (east)",
                "latitude": 60.71666666666667,
                "longitude": -135.05
            },
            "offsets": [
                "-08",
                "-07"
            ]
        },
        {
            "id": "America/Winnipeg",
            "aliases": [
                "Canada/Central"
            ],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Central - ON (west); Manitoba",
                "latitude": 49.88333333333333,
                "longitude": -97.15
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "America/Yakutat",
            "aliases": [],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Alaska - Yakutat",
                "latitude": 59.54694444444444,
                "longitude": -139.72722222222222
            },
            "offsets": [
                "-09",
                "-08"
            ]
        },
        {
            "id": "America/Yellowknife",
            "aliases": [],
            "location": {
                "countryCode": "CA",
                "countryName": "Canada",
                "comment": "Mountain - NT (central)",
                "latitude": 62.45,
                "longitude": -114.35
            },
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "Antarctica/Casey",
            "aliases": [],
            "location": {
                "countryCode": "AQ",
                "countryName": "Antarctica",
                "comment": "Casey",
                "latitude": -66.28333333333333,
                "longitude": 110.51666666666667
            },
            "offsets": [
                "\u002B08",
                "\u002B11"
            ]
        },
        {
            "id": "Antarctica/Davis",
            "aliases": [],
            "location": {
                "countryCode": "AQ",
                "countryName": "Antarctica",
                "comment": "Davis",
                "latitude": -68.58333333333333,
                "longitude": 77.96666666666667
            },
            "offsets": [
                "\u002B05",
                "\u002B07"
            ]
        },
        {
            "id": "Antarctica/Macquarie",
            "aliases": [],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Macquarie Island",
                "latitude": -54.5,
                "longitude": 158.95
            },
            "offsets": [
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "Antarctica/Mawson",
            "aliases": [],
            "location": {
                "countryCode": "AQ",
                "countryName": "Antarctica",
                "comment": "Mawson",
                "latitude": -67.6,
                "longitude": 62.88333333333333
            },
            "offsets": [
                "\u002B05",
                "\u002B06"
            ]
        },
        {
            "id": "Antarctica/Palmer",
            "aliases": [],
            "location": {
                "countryCode": "AQ",
                "countryName": "Antarctica",
                "comment": "Palmer",
                "latitude": -64.8,
                "longitude": -64.1
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "Antarctica/Rothera",
            "aliases": [],
            "location": {
                "countryCode": "AQ",
                "countryName": "Antarctica",
                "comment": "Rothera",
                "latitude": -67.56666666666666,
                "longitude": -68.13333333333334
            },
            "offsets": [
                "-03"
            ]
        },
        {
            "id": "Antarctica/Troll",
            "aliases": [],
            "location": {
                "countryCode": "AQ",
                "countryName": "Antarctica",
                "comment": "Troll",
                "latitude": -72.01138888888889,
                "longitude": 2.535
            },
            "offsets": [
                "\u002B00",
                "\u002B02"
            ]
        },
        {
            "id": "Antarctica/Vostok",
            "aliases": [],
            "location": {
                "countryCode": "AQ",
                "countryName": "Antarctica",
                "comment": "Vostok",
                "latitude": -78.4,
                "longitude": 106.9
            },
            "offsets": [
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Almaty",
            "aliases": [],
            "location": {
                "countryCode": "KZ",
                "countryName": "Kazakhstan",
                "comment": "Kazakhstan (most areas)",
                "latitude": 43.25,
                "longitude": 76.95
            },
            "offsets": [
                "\u002B06",
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Amman",
            "aliases": [],
            "location": {
                "countryCode": "JO",
                "countryName": "Jordan",
                "comment": "",
                "latitude": 31.95,
                "longitude": 35.93333333333333
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Anadyr",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B09 - Bering Sea",
                "latitude": 64.75,
                "longitude": 177.48333333333332
            },
            "offsets": [
                "\u002B11",
                "\u002B12",
                "\u002B13"
            ]
        },
        {
            "id": "Asia/Aqtau",
            "aliases": [],
            "location": {
                "countryCode": "KZ",
                "countryName": "Kazakhstan",
                "comment": "Mangghystau/Mankistau",
                "latitude": 44.516666666666666,
                "longitude": 50.266666666666666
            },
            "offsets": [
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Aqtobe",
            "aliases": [],
            "location": {
                "countryCode": "KZ",
                "countryName": "Kazakhstan",
                "comment": "Aqtobe/Aktobe",
                "latitude": 50.28333333333333,
                "longitude": 57.166666666666664
            },
            "offsets": [
                "\u002B05",
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Ashgabat",
            "aliases": [
                "Asia/Ashkhabad"
            ],
            "location": {
                "countryCode": "TM",
                "countryName": "Turkmenistan",
                "comment": "",
                "latitude": 37.95,
                "longitude": 58.38333333333333
            },
            "offsets": [
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Atyrau",
            "aliases": [],
            "location": {
                "countryCode": "KZ",
                "countryName": "Kazakhstan",
                "comment": "Atyrau/Atirau/Gur\u0027yev",
                "latitude": 47.11666666666667,
                "longitude": 51.93333333333333
            },
            "offsets": [
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Baghdad",
            "aliases": [],
            "location": {
                "countryCode": "IQ",
                "countryName": "Iraq",
                "comment": "",
                "latitude": 33.35,
                "longitude": 44.416666666666664
            },
            "offsets": [
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Asia/Baku",
            "aliases": [],
            "location": {
                "countryCode": "AZ",
                "countryName": "Azerbaijan",
                "comment": "",
                "latitude": 40.38333333333333,
                "longitude": 49.85
            },
            "offsets": [
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Bangkok",
            "aliases": [
                "Asia/Phnom_Penh",
                "Asia/Vientiane"
            ],
            "location": {
                "countryCode": "TH",
                "countryName": "Thailand",
                "comment": "",
                "latitude": 13.75,
                "longitude": 100.51666666666667
            },
            "offsets": [
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Barnaul",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B04 - Altai",
                "latitude": 53.36666666666667,
                "longitude": 83.75
            },
            "offsets": [
                "\u002B06",
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Beirut",
            "aliases": [],
            "location": {
                "countryCode": "LB",
                "countryName": "Lebanon",
                "comment": "",
                "latitude": 33.88333333333333,
                "longitude": 35.5
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Bishkek",
            "aliases": [],
            "location": {
                "countryCode": "KG",
                "countryName": "Kyrgyzstan",
                "comment": "",
                "latitude": 42.9,
                "longitude": 74.6
            },
            "offsets": [
                "\u002B05",
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Brunei",
            "aliases": [],
            "location": {
                "countryCode": "BN",
                "countryName": "Brunei",
                "comment": "",
                "latitude": 4.933333333333334,
                "longitude": 114.91666666666667
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Chita",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B06 - Zabaykalsky",
                "latitude": 52.05,
                "longitude": 113.46666666666667
            },
            "offsets": [
                "\u002B08",
                "\u002B09",
                "\u002B10"
            ]
        },
        {
            "id": "Asia/Choibalsan",
            "aliases": [],
            "location": {
                "countryCode": "MN",
                "countryName": "Mongolia",
                "comment": "Dornod, Sukhbaatar",
                "latitude": 48.06666666666667,
                "longitude": 114.5
            },
            "offsets": [
                "\u002B08",
                "\u002B09",
                "\u002B10"
            ]
        },
        {
            "id": "Asia/Colombo",
            "aliases": [],
            "location": {
                "countryCode": "LK",
                "countryName": "Sri Lanka",
                "comment": "",
                "latitude": 6.933333333333334,
                "longitude": 79.85
            },
            "offsets": [
                "\u002B05:30",
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Damascus",
            "aliases": [],
            "location": {
                "countryCode": "SY",
                "countryName": "Syria",
                "comment": "",
                "latitude": 33.5,
                "longitude": 36.3
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Dhaka",
            "aliases": [
                "Asia/Dacca"
            ],
            "location": {
                "countryCode": "BD",
                "countryName": "Bangladesh",
                "comment": "",
                "latitude": 23.716666666666665,
                "longitude": 90.41666666666667
            },
            "offsets": [
                "\u002B06",
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Dili",
            "aliases": [],
            "location": {
                "countryCode": "TL",
                "countryName": "East Timor",
                "comment": "",
                "latitude": -8.55,
                "longitude": 125.58333333333333
            },
            "offsets": [
                "\u002B08",
                "\u002B09"
            ]
        },
        {
            "id": "Asia/Dubai",
            "aliases": [
                "Asia/Muscat"
            ],
            "location": {
                "countryCode": "AE",
                "countryName": "United Arab Emirates",
                "comment": "",
                "latitude": 25.3,
                "longitude": 55.3
            },
            "offsets": [
                "\u002B04"
            ]
        },
        {
            "id": "Asia/Dushanbe",
            "aliases": [],
            "location": {
                "countryCode": "TJ",
                "countryName": "Tajikistan",
                "comment": "",
                "latitude": 38.583333333333336,
                "longitude": 68.8
            },
            "offsets": [
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Famagusta",
            "aliases": [],
            "location": {
                "countryCode": "CY",
                "countryName": "Cyprus",
                "comment": "Northern Cyprus",
                "latitude": 35.11666666666667,
                "longitude": 33.95
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Gaza",
            "aliases": [],
            "location": {
                "countryCode": "PS",
                "countryName": "Palestine",
                "comment": "Gaza Strip",
                "latitude": 31.5,
                "longitude": 34.46666666666667
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Hebron",
            "aliases": [],
            "location": {
                "countryCode": "PS",
                "countryName": "Palestine",
                "comment": "West Bank",
                "latitude": 31.533333333333335,
                "longitude": 35.095
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Ho_Chi_Minh",
            "aliases": [
                "Asia/Saigon"
            ],
            "location": {
                "countryCode": "VN",
                "countryName": "Vietnam",
                "comment": "",
                "latitude": 10.75,
                "longitude": 106.66666666666667
            },
            "offsets": [
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Hong_Kong",
            "aliases": [
                "Hongkong"
            ],
            "location": {
                "countryCode": "HK",
                "countryName": "Hong Kong",
                "comment": "",
                "latitude": 22.283333333333335,
                "longitude": 114.15
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Hovd",
            "aliases": [],
            "location": {
                "countryCode": "MN",
                "countryName": "Mongolia",
                "comment": "Bayan-Olgiy, Govi-Altai, Hovd, Uvs, Zavkhan",
                "latitude": 48.016666666666666,
                "longitude": 91.65
            },
            "offsets": [
                "\u002B07",
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Irkutsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B05 - Irkutsk, Buryatia",
                "latitude": 52.266666666666666,
                "longitude": 104.33333333333333
            },
            "offsets": [
                "\u002B08",
                "\u002B09"
            ]
        },
        {
            "id": "Asia/Jakarta",
            "aliases": [],
            "location": {
                "countryCode": "ID",
                "countryName": "Indonesia",
                "comment": "Java, Sumatra",
                "latitude": -6.166666666666667,
                "longitude": 106.8
            },
            "offsets": [
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Jayapura",
            "aliases": [],
            "location": {
                "countryCode": "ID",
                "countryName": "Indonesia",
                "comment": "New Guinea (West Papua / Irian Jaya); Malukus/Moluccas",
                "latitude": -2.533333333333333,
                "longitude": 140.7
            },
            "offsets": [
                "\u002B09"
            ]
        },
        {
            "id": "Asia/Jerusalem",
            "aliases": [
                "Asia/Tel_Aviv",
                "Israel"
            ],
            "location": {
                "countryCode": "IL",
                "countryName": "Israel",
                "comment": "",
                "latitude": 31.780555555555555,
                "longitude": 35.22388888888889
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Kabul",
            "aliases": [],
            "location": {
                "countryCode": "AF",
                "countryName": "Afghanistan",
                "comment": "",
                "latitude": 34.516666666666666,
                "longitude": 69.2
            },
            "offsets": [
                "\u002B04:30"
            ]
        },
        {
            "id": "Asia/Kamchatka",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B09 - Kamchatka",
                "latitude": 53.016666666666666,
                "longitude": 158.65
            },
            "offsets": [
                "\u002B11",
                "\u002B12",
                "\u002B13"
            ]
        },
        {
            "id": "Asia/Karachi",
            "aliases": [],
            "location": {
                "countryCode": "PK",
                "countryName": "Pakistan",
                "comment": "",
                "latitude": 24.866666666666667,
                "longitude": 67.05
            },
            "offsets": [
                "\u002B05",
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Kathmandu",
            "aliases": [
                "Asia/Katmandu"
            ],
            "location": {
                "countryCode": "NP",
                "countryName": "Nepal",
                "comment": "",
                "latitude": 27.716666666666665,
                "longitude": 85.31666666666666
            },
            "offsets": [
                "\u002B05:45"
            ]
        },
        {
            "id": "Asia/Khandyga",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B06 - Tomponsky, Ust-Maysky",
                "latitude": 62.65638888888889,
                "longitude": 135.55388888888888
            },
            "offsets": [
                "\u002B09",
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "Asia/Kolkata",
            "aliases": [
                "Asia/Calcutta"
            ],
            "location": {
                "countryCode": "IN",
                "countryName": "India",
                "comment": "",
                "latitude": 22.533333333333335,
                "longitude": 88.36666666666666
            },
            "offsets": [
                "\u002B05:30"
            ]
        },
        {
            "id": "Asia/Krasnoyarsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B04 - Krasnoyarsk area",
                "latitude": 56.016666666666666,
                "longitude": 92.83333333333333
            },
            "offsets": [
                "\u002B07",
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Kuala_Lumpur",
            "aliases": [],
            "location": {
                "countryCode": "MY",
                "countryName": "Malaysia",
                "comment": "Malaysia (peninsula)",
                "latitude": 3.1666666666666665,
                "longitude": 101.7
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Kuching",
            "aliases": [],
            "location": {
                "countryCode": "MY",
                "countryName": "Malaysia",
                "comment": "Sabah, Sarawak",
                "latitude": 1.55,
                "longitude": 110.33333333333333
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Macau",
            "aliases": [
                "Asia/Macao"
            ],
            "location": {
                "countryCode": "MO",
                "countryName": "Macau",
                "comment": "",
                "latitude": 22.197222222222223,
                "longitude": 113.54166666666667
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Magadan",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B08 - Magadan",
                "latitude": 59.56666666666667,
                "longitude": 150.8
            },
            "offsets": [
                "\u002B10",
                "\u002B11",
                "\u002B12"
            ]
        },
        {
            "id": "Asia/Makassar",
            "aliases": [
                "Asia/Ujung_Pandang"
            ],
            "location": {
                "countryCode": "ID",
                "countryName": "Indonesia",
                "comment": "Borneo (east, south); Sulawesi/Celebes, Bali, Nusa Tengarra; Timor (west)",
                "latitude": -5.116666666666666,
                "longitude": 119.4
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Manila",
            "aliases": [],
            "location": {
                "countryCode": "PH",
                "countryName": "Philippines",
                "comment": "",
                "latitude": 14.583333333333334,
                "longitude": 121
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Nicosia",
            "aliases": [
                "Europe/Nicosia"
            ],
            "location": {
                "countryCode": "CY",
                "countryName": "Cyprus",
                "comment": "Cyprus (most areas)",
                "latitude": 35.166666666666664,
                "longitude": 33.36666666666667
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Novokuznetsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B04 - Kemerovo",
                "latitude": 53.75,
                "longitude": 87.11666666666666
            },
            "offsets": [
                "\u002B06",
                "\u002B07",
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Novosibirsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B04 - Novosibirsk",
                "latitude": 55.03333333333333,
                "longitude": 82.91666666666667
            },
            "offsets": [
                "\u002B06",
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Omsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B03 - Omsk",
                "latitude": 55,
                "longitude": 73.4
            },
            "offsets": [
                "\u002B06",
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Oral",
            "aliases": [],
            "location": {
                "countryCode": "KZ",
                "countryName": "Kazakhstan",
                "comment": "West Kazakhstan",
                "latitude": 51.21666666666667,
                "longitude": 51.35
            },
            "offsets": [
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Pontianak",
            "aliases": [],
            "location": {
                "countryCode": "ID",
                "countryName": "Indonesia",
                "comment": "Borneo (west, central)",
                "latitude": -0.03333333333333333,
                "longitude": 109.33333333333333
            },
            "offsets": [
                "\u002B07"
            ]
        },
        {
            "id": "Asia/Pyongyang",
            "aliases": [],
            "location": {
                "countryCode": "KP",
                "countryName": "Korea (North)",
                "comment": "",
                "latitude": 39.016666666666666,
                "longitude": 125.75
            },
            "offsets": [
                "\u002B08:30",
                "\u002B09"
            ]
        },
        {
            "id": "Asia/Qatar",
            "aliases": [
                "Asia/Bahrain"
            ],
            "location": {
                "countryCode": "QA",
                "countryName": "Qatar",
                "comment": "",
                "latitude": 25.283333333333335,
                "longitude": 51.53333333333333
            },
            "offsets": [
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Qostanay",
            "aliases": [],
            "location": {
                "countryCode": "KZ",
                "countryName": "Kazakhstan",
                "comment": "Qostanay/Kostanay/Kustanay",
                "latitude": 53.2,
                "longitude": 63.61666666666667
            },
            "offsets": [
                "\u002B05",
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Qyzylorda",
            "aliases": [],
            "location": {
                "countryCode": "KZ",
                "countryName": "Kazakhstan",
                "comment": "Qyzylorda/Kyzylorda/Kzyl-Orda",
                "latitude": 44.8,
                "longitude": 65.46666666666667
            },
            "offsets": [
                "\u002B05",
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Riyadh",
            "aliases": [
                "Antarctica/Syowa",
                "Asia/Aden",
                "Asia/Kuwait"
            ],
            "location": {
                "countryCode": "SA",
                "countryName": "Saudi Arabia",
                "comment": "",
                "latitude": 24.633333333333333,
                "longitude": 46.71666666666667
            },
            "offsets": [
                "\u002B03"
            ]
        },
        {
            "id": "Asia/Sakhalin",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B08 - Sakhalin Island",
                "latitude": 46.96666666666667,
                "longitude": 142.7
            },
            "offsets": [
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "Asia/Samarkand",
            "aliases": [],
            "location": {
                "countryCode": "UZ",
                "countryName": "Uzbekistan",
                "comment": "Uzbekistan (west)",
                "latitude": 39.666666666666664,
                "longitude": 66.8
            },
            "offsets": [
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Seoul",
            "aliases": [
                "ROK"
            ],
            "location": {
                "countryCode": "KR",
                "countryName": "Korea (South)",
                "comment": "",
                "latitude": 37.55,
                "longitude": 126.96666666666667
            },
            "offsets": [
                "\u002B09"
            ]
        },
        {
            "id": "Asia/Shanghai",
            "aliases": [
                "Asia/Chongqing",
                "Asia/Chungking",
                "Asia/Harbin",
                "PRC"
            ],
            "location": {
                "countryCode": "CN",
                "countryName": "China",
                "comment": "Beijing Time",
                "latitude": 31.233333333333334,
                "longitude": 121.46666666666667
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Singapore",
            "aliases": [
                "Singapore"
            ],
            "location": {
                "countryCode": "SG",
                "countryName": "Singapore",
                "comment": "",
                "latitude": 1.2833333333333334,
                "longitude": 103.85
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Srednekolymsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B08 - Sakha (E); North Kuril Is",
                "latitude": 67.46666666666667,
                "longitude": 153.71666666666667
            },
            "offsets": [
                "\u002B11",
                "\u002B12"
            ]
        },
        {
            "id": "Asia/Taipei",
            "aliases": [
                "ROC"
            ],
            "location": {
                "countryCode": "TW",
                "countryName": "Taiwan",
                "comment": "",
                "latitude": 25.05,
                "longitude": 121.5
            },
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Tashkent",
            "aliases": [],
            "location": {
                "countryCode": "UZ",
                "countryName": "Uzbekistan",
                "comment": "Uzbekistan (east)",
                "latitude": 41.333333333333336,
                "longitude": 69.3
            },
            "offsets": [
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Tbilisi",
            "aliases": [],
            "location": {
                "countryCode": "GE",
                "countryName": "Georgia",
                "comment": "",
                "latitude": 41.71666666666667,
                "longitude": 44.81666666666667
            },
            "offsets": [
                "\u002B03",
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Asia/Tehran",
            "aliases": [
                "Iran"
            ],
            "location": {
                "countryCode": "IR",
                "countryName": "Iran",
                "comment": "",
                "latitude": 35.666666666666664,
                "longitude": 51.43333333333333
            },
            "offsets": [
                "\u002B03:30",
                "\u002B04:30"
            ]
        },
        {
            "id": "Asia/Thimphu",
            "aliases": [
                "Asia/Thimbu"
            ],
            "location": {
                "countryCode": "BT",
                "countryName": "Bhutan",
                "comment": "",
                "latitude": 27.466666666666665,
                "longitude": 89.65
            },
            "offsets": [
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Tokyo",
            "aliases": [
                "Japan"
            ],
            "location": {
                "countryCode": "JP",
                "countryName": "Japan",
                "comment": "",
                "latitude": 35.654444444444444,
                "longitude": 139.7447222222222
            },
            "offsets": [
                "\u002B09"
            ]
        },
        {
            "id": "Asia/Tomsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B04 - Tomsk",
                "latitude": 56.5,
                "longitude": 84.96666666666667
            },
            "offsets": [
                "\u002B06",
                "\u002B07",
                "\u002B08"
            ]
        },
        {
            "id": "Asia/Ulaanbaatar",
            "aliases": [
                "Asia/Ulan_Bator"
            ],
            "location": {
                "countryCode": "MN",
                "countryName": "Mongolia",
                "comment": "Mongolia (most areas)",
                "latitude": 47.916666666666664,
                "longitude": 106.88333333333334
            },
            "offsets": [
                "\u002B08",
                "\u002B09"
            ]
        },
        {
            "id": "Asia/Urumqi",
            "aliases": [
                "Asia/Kashgar"
            ],
            "location": {
                "countryCode": "CN",
                "countryName": "China",
                "comment": "Xinjiang Time",
                "latitude": 43.8,
                "longitude": 87.58333333333333
            },
            "offsets": [
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Ust-Nera",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B07 - Oymyakonsky",
                "latitude": 64.56027777777778,
                "longitude": 143.22666666666666
            },
            "offsets": [
                "\u002B10",
                "\u002B11",
                "\u002B12"
            ]
        },
        {
            "id": "Asia/Vladivostok",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B07 - Amur River",
                "latitude": 43.166666666666664,
                "longitude": 131.93333333333334
            },
            "offsets": [
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "Asia/Yakutsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B06 - Lena River",
                "latitude": 62,
                "longitude": 129.66666666666666
            },
            "offsets": [
                "\u002B09",
                "\u002B10"
            ]
        },
        {
            "id": "Asia/Yangon",
            "aliases": [
                "Asia/Rangoon"
            ],
            "location": {
                "countryCode": "MM",
                "countryName": "Myanmar (Burma)",
                "comment": "",
                "latitude": 16.783333333333335,
                "longitude": 96.16666666666667
            },
            "offsets": [
                "\u002B06:30"
            ]
        },
        {
            "id": "Asia/Yekaterinburg",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B02 - Urals",
                "latitude": 56.85,
                "longitude": 60.6
            },
            "offsets": [
                "\u002B05",
                "\u002B06"
            ]
        },
        {
            "id": "Asia/Yerevan",
            "aliases": [],
            "location": {
                "countryCode": "AM",
                "countryName": "Armenia",
                "comment": "",
                "latitude": 40.18333333333333,
                "longitude": 44.5
            },
            "offsets": [
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Atlantic/Azores",
            "aliases": [],
            "location": {
                "countryCode": "PT",
                "countryName": "Portugal",
                "comment": "Azores",
                "latitude": 37.733333333333334,
                "longitude": -25.666666666666668
            },
            "offsets": [
                "-01",
                "\u002B00"
            ]
        },
        {
            "id": "Atlantic/Bermuda",
            "aliases": [],
            "location": {
                "countryCode": "BM",
                "countryName": "Bermuda",
                "comment": "",
                "latitude": 32.28333333333333,
                "longitude": -64.76666666666667
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "Atlantic/Canary",
            "aliases": [],
            "location": {
                "countryCode": "ES",
                "countryName": "Spain",
                "comment": "Canary Islands",
                "latitude": 28.1,
                "longitude": -15.4
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Atlantic/Cape_Verde",
            "aliases": [],
            "location": {
                "countryCode": "CV",
                "countryName": "Cape Verde",
                "comment": "",
                "latitude": 14.916666666666666,
                "longitude": -23.516666666666666
            },
            "offsets": [
                "-01"
            ]
        },
        {
            "id": "Atlantic/Faroe",
            "aliases": [
                "Atlantic/Faeroe"
            ],
            "location": {
                "countryCode": "FO",
                "countryName": "Faroe Islands",
                "comment": "",
                "latitude": 62.016666666666666,
                "longitude": -6.766666666666667
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Atlantic/Madeira",
            "aliases": [],
            "location": {
                "countryCode": "PT",
                "countryName": "Portugal",
                "comment": "Madeira Islands",
                "latitude": 32.63333333333333,
                "longitude": -16.9
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Atlantic/Reykjavik",
            "aliases": [
                "Iceland"
            ],
            "location": {
                "countryCode": "IS",
                "countryName": "Iceland",
                "comment": "",
                "latitude": 64.15,
                "longitude": -21.85
            },
            "offsets": [
                "\u002B00"
            ]
        },
        {
            "id": "Atlantic/South_Georgia",
            "aliases": [],
            "location": {
                "countryCode": "GS",
                "countryName": "South Georgia \u0026 the South Sandwich Islands",
                "comment": "",
                "latitude": -54.266666666666666,
                "longitude": -36.53333333333333
            },
            "offsets": [
                "-02"
            ]
        },
        {
            "id": "Atlantic/Stanley",
            "aliases": [],
            "location": {
                "countryCode": "FK",
                "countryName": "Falkland Islands",
                "comment": "",
                "latitude": -51.7,
                "longitude": -57.85
            },
            "offsets": [
                "-04",
                "-03"
            ]
        },
        {
            "id": "Australia/Adelaide",
            "aliases": [
                "Australia/South"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "South Australia",
                "latitude": -34.916666666666664,
                "longitude": 138.58333333333334
            },
            "offsets": [
                "\u002B09:30",
                "\u002B10:30"
            ]
        },
        {
            "id": "Australia/Brisbane",
            "aliases": [
                "Australia/Queensland"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Queensland (most areas)",
                "latitude": -27.466666666666665,
                "longitude": 153.03333333333333
            },
            "offsets": [
                "\u002B10"
            ]
        },
        {
            "id": "Australia/Broken_Hill",
            "aliases": [
                "Australia/Yancowinna"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "New South Wales (Yancowinna)",
                "latitude": -31.95,
                "longitude": 141.45
            },
            "offsets": [
                "\u002B09:30",
                "\u002B10:30"
            ]
        },
        {
            "id": "Australia/Darwin",
            "aliases": [
                "Australia/North"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Northern Territory",
                "latitude": -12.466666666666667,
                "longitude": 130.83333333333334
            },
            "offsets": [
                "\u002B09:30"
            ]
        },
        {
            "id": "Australia/Eucla",
            "aliases": [],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Western Australia (Eucla)",
                "latitude": -31.716666666666665,
                "longitude": 128.86666666666667
            },
            "offsets": [
                "\u002B08:45",
                "\u002B09:45"
            ]
        },
        {
            "id": "Australia/Hobart",
            "aliases": [
                "Australia/Currie",
                "Australia/Tasmania"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Tasmania",
                "latitude": -42.88333333333333,
                "longitude": 147.31666666666666
            },
            "offsets": [
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "Australia/Lindeman",
            "aliases": [],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Queensland (Whitsunday Islands)",
                "latitude": -20.266666666666666,
                "longitude": 149
            },
            "offsets": [
                "\u002B10"
            ]
        },
        {
            "id": "Australia/Lord_Howe",
            "aliases": [
                "Australia/LHI"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Lord Howe Island",
                "latitude": -31.55,
                "longitude": 159.08333333333334
            },
            "offsets": [
                "\u002B10:30",
                "\u002B11"
            ]
        },
        {
            "id": "Australia/Melbourne",
            "aliases": [
                "Australia/Victoria"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Victoria",
                "latitude": -37.81666666666667,
                "longitude": 144.96666666666667
            },
            "offsets": [
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "Australia/Perth",
            "aliases": [
                "Australia/West"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "Western Australia (most areas)",
                "latitude": -31.95,
                "longitude": 115.85
            },
            "offsets": [
                "\u002B08",
                "\u002B09"
            ]
        },
        {
            "id": "Australia/Sydney",
            "aliases": [
                "Australia/ACT",
                "Australia/Canberra",
                "Australia/NSW"
            ],
            "location": {
                "countryCode": "AU",
                "countryName": "Australia",
                "comment": "New South Wales (most areas)",
                "latitude": -33.86666666666667,
                "longitude": 151.21666666666667
            },
            "offsets": [
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "CET",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "CST6CDT",
            "aliases": [],
            "location": null,
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "EET",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "EST",
            "aliases": [],
            "location": null,
            "offsets": [
                "-05"
            ]
        },
        {
            "id": "EST5EDT",
            "aliases": [],
            "location": null,
            "offsets": [
                "-05",
                "-04"
            ]
        },
        {
            "id": "Etc/GMT",
            "aliases": [
                "Etc/GMT\u002B0",
                "Etc/GMT-0",
                "Etc/GMT0",
                "Etc/Greenwich",
                "GMT",
                "GMT\u002B0",
                "GMT-0",
                "GMT0",
                "Greenwich"
            ],
            "location": null,
            "offsets": [
                "\u002B00"
            ]
        },
        {
            "id": "Etc/GMT-1",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B01"
            ]
        },
        {
            "id": "Etc/GMT-10",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B10"
            ]
        },
        {
            "id": "Etc/GMT-11",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B11"
            ]
        },
        {
            "id": "Etc/GMT-12",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "Etc/GMT-13",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B13"
            ]
        },
        {
            "id": "Etc/GMT-14",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B14"
            ]
        },
        {
            "id": "Etc/GMT-2",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B02"
            ]
        },
        {
            "id": "Etc/GMT-3",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B03"
            ]
        },
        {
            "id": "Etc/GMT-4",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B04"
            ]
        },
        {
            "id": "Etc/GMT-5",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B05"
            ]
        },
        {
            "id": "Etc/GMT-6",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B06"
            ]
        },
        {
            "id": "Etc/GMT-7",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B07"
            ]
        },
        {
            "id": "Etc/GMT-8",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B08"
            ]
        },
        {
            "id": "Etc/GMT-9",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B09"
            ]
        },
        {
            "id": "Etc/GMT\u002B1",
            "aliases": [],
            "location": null,
            "offsets": [
                "-01"
            ]
        },
        {
            "id": "Etc/GMT\u002B10",
            "aliases": [],
            "location": null,
            "offsets": [
                "-10"
            ]
        },
        {
            "id": "Etc/GMT\u002B11",
            "aliases": [],
            "location": null,
            "offsets": [
                "-11"
            ]
        },
        {
            "id": "Etc/GMT\u002B12",
            "aliases": [],
            "location": null,
            "offsets": [
                "-12"
            ]
        },
        {
            "id": "Etc/GMT\u002B2",
            "aliases": [],
            "location": null,
            "offsets": [
                "-02"
            ]
        },
        {
            "id": "Etc/GMT\u002B3",
            "aliases": [],
            "location": null,
            "offsets": [
                "-03"
            ]
        },
        {
            "id": "Etc/GMT\u002B4",
            "aliases": [],
            "location": null,
            "offsets": [
                "-04"
            ]
        },
        {
            "id": "Etc/GMT\u002B5",
            "aliases": [],
            "location": null,
            "offsets": [
                "-05"
            ]
        },
        {
            "id": "Etc/GMT\u002B6",
            "aliases": [],
            "location": null,
            "offsets": [
                "-06"
            ]
        },
        {
            "id": "Etc/GMT\u002B7",
            "aliases": [],
            "location": null,
            "offsets": [
                "-07"
            ]
        },
        {
            "id": "Etc/GMT\u002B8",
            "aliases": [],
            "location": null,
            "offsets": [
                "-08"
            ]
        },
        {
            "id": "Etc/GMT\u002B9",
            "aliases": [],
            "location": null,
            "offsets": [
                "-09"
            ]
        },
        {
            "id": "Etc/UTC",
            "aliases": [
                "Etc/UCT",
                "Etc/Universal",
                "Etc/Zulu",
                "UCT",
                "UTC",
                "Universal",
                "Zulu"
            ],
            "location": null,
            "offsets": [
                "\u002B00"
            ]
        },
        {
            "id": "Europe/Amsterdam",
            "aliases": [],
            "location": {
                "countryCode": "NL",
                "countryName": "Netherlands",
                "comment": "",
                "latitude": 52.36666666666667,
                "longitude": 4.9
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Andorra",
            "aliases": [],
            "location": {
                "countryCode": "AD",
                "countryName": "Andorra",
                "comment": "",
                "latitude": 42.5,
                "longitude": 1.5166666666666666
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Astrakhan",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B01 - Astrakhan",
                "latitude": 46.35,
                "longitude": 48.05
            },
            "offsets": [
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Europe/Athens",
            "aliases": [],
            "location": {
                "countryCode": "GR",
                "countryName": "Greece",
                "comment": "",
                "latitude": 37.96666666666667,
                "longitude": 23.716666666666665
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Belgrade",
            "aliases": [
                "Europe/Ljubljana",
                "Europe/Podgorica",
                "Europe/Sarajevo",
                "Europe/Skopje",
                "Europe/Zagreb"
            ],
            "location": {
                "countryCode": "RS",
                "countryName": "Serbia",
                "comment": "",
                "latitude": 44.833333333333336,
                "longitude": 20.5
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Berlin",
            "aliases": [],
            "location": {
                "countryCode": "DE",
                "countryName": "Germany",
                "comment": "Germany (most areas)",
                "latitude": 52.5,
                "longitude": 13.366666666666667
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Brussels",
            "aliases": [],
            "location": {
                "countryCode": "BE",
                "countryName": "Belgium",
                "comment": "",
                "latitude": 50.833333333333336,
                "longitude": 4.333333333333333
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Bucharest",
            "aliases": [],
            "location": {
                "countryCode": "RO",
                "countryName": "Romania",
                "comment": "",
                "latitude": 44.43333333333333,
                "longitude": 26.1
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Budapest",
            "aliases": [],
            "location": {
                "countryCode": "HU",
                "countryName": "Hungary",
                "comment": "",
                "latitude": 47.5,
                "longitude": 19.083333333333332
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Chisinau",
            "aliases": [
                "Europe/Tiraspol"
            ],
            "location": {
                "countryCode": "MD",
                "countryName": "Moldova",
                "comment": "",
                "latitude": 47,
                "longitude": 28.833333333333332
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Copenhagen",
            "aliases": [],
            "location": {
                "countryCode": "DK",
                "countryName": "Denmark",
                "comment": "",
                "latitude": 55.666666666666664,
                "longitude": 12.583333333333334
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Dublin",
            "aliases": [
                "Eire"
            ],
            "location": {
                "countryCode": "IE",
                "countryName": "Ireland",
                "comment": "",
                "latitude": 53.333333333333336,
                "longitude": -6.25
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Europe/Gibraltar",
            "aliases": [],
            "location": {
                "countryCode": "GI",
                "countryName": "Gibraltar",
                "comment": "",
                "latitude": 36.13333333333333,
                "longitude": -5.35
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Helsinki",
            "aliases": [
                "Europe/Mariehamn"
            ],
            "location": {
                "countryCode": "FI",
                "countryName": "Finland",
                "comment": "",
                "latitude": 60.166666666666664,
                "longitude": 24.966666666666665
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Istanbul",
            "aliases": [
                "Asia/Istanbul",
                "Turkey"
            ],
            "location": {
                "countryCode": "TR",
                "countryName": "Turkey",
                "comment": "",
                "latitude": 41.016666666666666,
                "longitude": 28.966666666666665
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Kaliningrad",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK-01 - Kaliningrad",
                "latitude": 54.71666666666667,
                "longitude": 20.5
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Kiev",
            "aliases": [],
            "location": {
                "countryCode": "UA",
                "countryName": "Ukraine",
                "comment": "Ukraine (most areas)",
                "latitude": 50.43333333333333,
                "longitude": 30.516666666666666
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Kirov",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B00 - Kirov",
                "latitude": 58.6,
                "longitude": 49.65
            },
            "offsets": [
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Europe/Lisbon",
            "aliases": [
                "Portugal"
            ],
            "location": {
                "countryCode": "PT",
                "countryName": "Portugal",
                "comment": "Portugal (mainland)",
                "latitude": 38.71666666666667,
                "longitude": -9.133333333333333
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Europe/London",
            "aliases": [
                "Europe/Belfast",
                "Europe/Guernsey",
                "Europe/Isle_of_Man",
                "Europe/Jersey",
                "GB",
                "GB-Eire"
            ],
            "location": {
                "countryCode": "GB",
                "countryName": "Britain (UK)",
                "comment": "",
                "latitude": 51.50833333333333,
                "longitude": -0.12527777777777777
            },
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        },
        {
            "id": "Europe/Luxembourg",
            "aliases": [],
            "location": {
                "countryCode": "LU",
                "countryName": "Luxembourg",
                "comment": "",
                "latitude": 49.6,
                "longitude": 6.15
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Madrid",
            "aliases": [],
            "location": {
                "countryCode": "ES",
                "countryName": "Spain",
                "comment": "Spain (mainland)",
                "latitude": 40.4,
                "longitude": -3.683333333333333
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Malta",
            "aliases": [],
            "location": {
                "countryCode": "MT",
                "countryName": "Malta",
                "comment": "",
                "latitude": 35.9,
                "longitude": 14.516666666666667
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Minsk",
            "aliases": [],
            "location": {
                "countryCode": "BY",
                "countryName": "Belarus",
                "comment": "",
                "latitude": 53.9,
                "longitude": 27.566666666666666
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Monaco",
            "aliases": [],
            "location": {
                "countryCode": "MC",
                "countryName": "Monaco",
                "comment": "",
                "latitude": 43.7,
                "longitude": 7.383333333333334
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Moscow",
            "aliases": [
                "W-SU"
            ],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B00 - Moscow area",
                "latitude": 55.755833333333335,
                "longitude": 37.617777777777775
            },
            "offsets": [
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Europe/Oslo",
            "aliases": [
                "Arctic/Longyearbyen",
                "Atlantic/Jan_Mayen"
            ],
            "location": {
                "countryCode": "NO",
                "countryName": "Norway",
                "comment": "",
                "latitude": 59.916666666666664,
                "longitude": 10.75
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Paris",
            "aliases": [],
            "location": {
                "countryCode": "FR",
                "countryName": "France",
                "comment": "",
                "latitude": 48.86666666666667,
                "longitude": 2.3333333333333335
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Prague",
            "aliases": [
                "Europe/Bratislava"
            ],
            "location": {
                "countryCode": "CZ",
                "countryName": "Czech Republic",
                "comment": "",
                "latitude": 50.083333333333336,
                "longitude": 14.433333333333334
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Riga",
            "aliases": [],
            "location": {
                "countryCode": "LV",
                "countryName": "Latvia",
                "comment": "",
                "latitude": 56.95,
                "longitude": 24.1
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Rome",
            "aliases": [
                "Europe/San_Marino",
                "Europe/Vatican"
            ],
            "location": {
                "countryCode": "IT",
                "countryName": "Italy",
                "comment": "",
                "latitude": 41.9,
                "longitude": 12.483333333333333
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Samara",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B01 - Samara, Udmurtia",
                "latitude": 53.2,
                "longitude": 50.15
            },
            "offsets": [
                "\u002B03",
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Europe/Saratov",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B01 - Saratov",
                "latitude": 51.56666666666667,
                "longitude": 46.03333333333333
            },
            "offsets": [
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Europe/Simferopol",
            "aliases": [],
            "location": {
                "countryCode": "UA",
                "countryName": "Ukraine",
                "comment": "Crimea",
                "latitude": 44.95,
                "longitude": 34.1
            },
            "offsets": [
                "\u002B02",
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Europe/Sofia",
            "aliases": [],
            "location": {
                "countryCode": "BG",
                "countryName": "Bulgaria",
                "comment": "",
                "latitude": 42.68333333333333,
                "longitude": 23.316666666666666
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Stockholm",
            "aliases": [],
            "location": {
                "countryCode": "SE",
                "countryName": "Sweden",
                "comment": "",
                "latitude": 59.333333333333336,
                "longitude": 18.05
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Tallinn",
            "aliases": [],
            "location": {
                "countryCode": "EE",
                "countryName": "Estonia",
                "comment": "",
                "latitude": 59.416666666666664,
                "longitude": 24.75
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Tirane",
            "aliases": [],
            "location": {
                "countryCode": "AL",
                "countryName": "Albania",
                "comment": "",
                "latitude": 41.333333333333336,
                "longitude": 19.833333333333332
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Ulyanovsk",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B01 - Ulyanovsk",
                "latitude": 54.333333333333336,
                "longitude": 48.4
            },
            "offsets": [
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Europe/Uzhgorod",
            "aliases": [],
            "location": {
                "countryCode": "UA",
                "countryName": "Ukraine",
                "comment": "Transcarpathia",
                "latitude": 48.61666666666667,
                "longitude": 22.3
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Vienna",
            "aliases": [],
            "location": {
                "countryCode": "AT",
                "countryName": "Austria",
                "comment": "",
                "latitude": 48.21666666666667,
                "longitude": 16.333333333333332
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Vilnius",
            "aliases": [],
            "location": {
                "countryCode": "LT",
                "countryName": "Lithuania",
                "comment": "",
                "latitude": 54.68333333333333,
                "longitude": 25.316666666666666
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Volgograd",
            "aliases": [],
            "location": {
                "countryCode": "RU",
                "countryName": "Russia",
                "comment": "MSK\u002B00 - Volgograd",
                "latitude": 48.733333333333334,
                "longitude": 44.416666666666664
            },
            "offsets": [
                "\u002B03",
                "\u002B04"
            ]
        },
        {
            "id": "Europe/Warsaw",
            "aliases": [
                "Poland"
            ],
            "location": {
                "countryCode": "PL",
                "countryName": "Poland",
                "comment": "",
                "latitude": 52.25,
                "longitude": 21
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "Europe/Zaporozhye",
            "aliases": [],
            "location": {
                "countryCode": "UA",
                "countryName": "Ukraine",
                "comment": "Zaporozhye and east Lugansk",
                "latitude": 47.833333333333336,
                "longitude": 35.166666666666664
            },
            "offsets": [
                "\u002B02",
                "\u002B03"
            ]
        },
        {
            "id": "Europe/Zurich",
            "aliases": [
                "Europe/Busingen",
                "Europe/Vaduz"
            ],
            "location": {
                "countryCode": "CH",
                "countryName": "Switzerland",
                "comment": "",
                "latitude": 47.38333333333333,
                "longitude": 8.533333333333333
            },
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "HST",
            "aliases": [],
            "location": null,
            "offsets": [
                "-10"
            ]
        },
        {
            "id": "Indian/Chagos",
            "aliases": [],
            "location": {
                "countryCode": "IO",
                "countryName": "British Indian Ocean Territory",
                "comment": "",
                "latitude": -7.333333333333333,
                "longitude": 72.41666666666667
            },
            "offsets": [
                "\u002B06"
            ]
        },
        {
            "id": "Indian/Christmas",
            "aliases": [],
            "location": {
                "countryCode": "CX",
                "countryName": "Christmas Island",
                "comment": "",
                "latitude": -10.416666666666666,
                "longitude": 105.71666666666667
            },
            "offsets": [
                "\u002B07"
            ]
        },
        {
            "id": "Indian/Cocos",
            "aliases": [],
            "location": {
                "countryCode": "CC",
                "countryName": "Cocos (Keeling) Islands",
                "comment": "",
                "latitude": -12.166666666666666,
                "longitude": 96.91666666666667
            },
            "offsets": [
                "\u002B06:30"
            ]
        },
        {
            "id": "Indian/Kerguelen",
            "aliases": [],
            "location": {
                "countryCode": "TF",
                "countryName": "French Southern \u0026 Antarctic Lands",
                "comment": "",
                "latitude": -49.352777777777774,
                "longitude": 70.2175
            },
            "offsets": [
                "\u002B05"
            ]
        },
        {
            "id": "Indian/Mahe",
            "aliases": [],
            "location": {
                "countryCode": "SC",
                "countryName": "Seychelles",
                "comment": "",
                "latitude": -4.666666666666667,
                "longitude": 55.46666666666667
            },
            "offsets": [
                "\u002B04"
            ]
        },
        {
            "id": "Indian/Maldives",
            "aliases": [],
            "location": {
                "countryCode": "MV",
                "countryName": "Maldives",
                "comment": "",
                "latitude": 4.166666666666667,
                "longitude": 73.5
            },
            "offsets": [
                "\u002B05"
            ]
        },
        {
            "id": "Indian/Mauritius",
            "aliases": [],
            "location": {
                "countryCode": "MU",
                "countryName": "Mauritius",
                "comment": "",
                "latitude": -20.166666666666668,
                "longitude": 57.5
            },
            "offsets": [
                "\u002B04",
                "\u002B05"
            ]
        },
        {
            "id": "Indian/Reunion",
            "aliases": [],
            "location": {
                "countryCode": "RE",
                "countryName": "R\u00E9union",
                "comment": "",
                "latitude": -20.866666666666667,
                "longitude": 55.46666666666667
            },
            "offsets": [
                "\u002B04"
            ]
        },
        {
            "id": "MET",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B01",
                "\u002B02"
            ]
        },
        {
            "id": "MST",
            "aliases": [],
            "location": null,
            "offsets": [
                "-07"
            ]
        },
        {
            "id": "MST7MDT",
            "aliases": [],
            "location": null,
            "offsets": [
                "-07",
                "-06"
            ]
        },
        {
            "id": "Pacific/Apia",
            "aliases": [],
            "location": {
                "countryCode": "WS",
                "countryName": "Samoa (western)",
                "comment": "",
                "latitude": -13.833333333333334,
                "longitude": -171.73333333333332
            },
            "offsets": [
                "-11",
                "-10",
                "\u002B13",
                "\u002B14"
            ]
        },
        {
            "id": "Pacific/Auckland",
            "aliases": [
                "Antarctica/McMurdo",
                "Antarctica/South_Pole",
                "NZ"
            ],
            "location": {
                "countryCode": "NZ",
                "countryName": "New Zealand",
                "comment": "New Zealand (most areas)",
                "latitude": -36.86666666666667,
                "longitude": 174.76666666666668
            },
            "offsets": [
                "\u002B12",
                "\u002B13"
            ]
        },
        {
            "id": "Pacific/Bougainville",
            "aliases": [],
            "location": {
                "countryCode": "PG",
                "countryName": "Papua New Guinea",
                "comment": "Bougainville",
                "latitude": -6.216666666666667,
                "longitude": 155.56666666666666
            },
            "offsets": [
                "\u002B10",
                "\u002B11"
            ]
        },
        {
            "id": "Pacific/Chatham",
            "aliases": [
                "NZ-CHAT"
            ],
            "location": {
                "countryCode": "NZ",
                "countryName": "New Zealand",
                "comment": "Chatham Islands",
                "latitude": -43.95,
                "longitude": -176.55
            },
            "offsets": [
                "\u002B12:45",
                "\u002B13:45"
            ]
        },
        {
            "id": "Pacific/Chuuk",
            "aliases": [
                "Pacific/Truk",
                "Pacific/Yap"
            ],
            "location": {
                "countryCode": "FM",
                "countryName": "Micronesia",
                "comment": "Chuuk/Truk, Yap",
                "latitude": 7.416666666666667,
                "longitude": 151.78333333333333
            },
            "offsets": [
                "\u002B10"
            ]
        },
        {
            "id": "Pacific/Easter",
            "aliases": [
                "Chile/EasterIsland"
            ],
            "location": {
                "countryCode": "CL",
                "countryName": "Chile",
                "comment": "Easter Island",
                "latitude": -27.15,
                "longitude": -109.43333333333334
            },
            "offsets": [
                "-06",
                "-05"
            ]
        },
        {
            "id": "Pacific/Efate",
            "aliases": [],
            "location": {
                "countryCode": "VU",
                "countryName": "Vanuatu",
                "comment": "",
                "latitude": -17.666666666666668,
                "longitude": 168.41666666666666
            },
            "offsets": [
                "\u002B11"
            ]
        },
        {
            "id": "Pacific/Fakaofo",
            "aliases": [],
            "location": {
                "countryCode": "TK",
                "countryName": "Tokelau",
                "comment": "",
                "latitude": -9.366666666666667,
                "longitude": -171.23333333333332
            },
            "offsets": [
                "-11",
                "\u002B13"
            ]
        },
        {
            "id": "Pacific/Fiji",
            "aliases": [],
            "location": {
                "countryCode": "FJ",
                "countryName": "Fiji",
                "comment": "",
                "latitude": -18.133333333333333,
                "longitude": 178.41666666666666
            },
            "offsets": [
                "\u002B12",
                "\u002B13"
            ]
        },
        {
            "id": "Pacific/Funafuti",
            "aliases": [],
            "location": {
                "countryCode": "TV",
                "countryName": "Tuvalu",
                "comment": "",
                "latitude": -8.516666666666667,
                "longitude": 179.21666666666667
            },
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "Pacific/Galapagos",
            "aliases": [],
            "location": {
                "countryCode": "EC",
                "countryName": "Ecuador",
                "comment": "Galapagos Islands",
                "latitude": -0.9,
                "longitude": -89.6
            },
            "offsets": [
                "-06"
            ]
        },
        {
            "id": "Pacific/Gambier",
            "aliases": [],
            "location": {
                "countryCode": "PF",
                "countryName": "French Polynesia",
                "comment": "Gambier Islands",
                "latitude": -23.133333333333333,
                "longitude": -134.95
            },
            "offsets": [
                "-09"
            ]
        },
        {
            "id": "Pacific/Guadalcanal",
            "aliases": [],
            "location": {
                "countryCode": "SB",
                "countryName": "Solomon Islands",
                "comment": "",
                "latitude": -9.533333333333333,
                "longitude": 160.2
            },
            "offsets": [
                "\u002B11"
            ]
        },
        {
            "id": "Pacific/Guam",
            "aliases": [
                "Pacific/Saipan"
            ],
            "location": {
                "countryCode": "GU",
                "countryName": "Guam",
                "comment": "",
                "latitude": 13.466666666666667,
                "longitude": 144.75
            },
            "offsets": [
                "\u002B10"
            ]
        },
        {
            "id": "Pacific/Honolulu",
            "aliases": [
                "Pacific/Johnston",
                "US/Hawaii"
            ],
            "location": {
                "countryCode": "US",
                "countryName": "United States",
                "comment": "Hawaii",
                "latitude": 21.306944444444444,
                "longitude": -157.85833333333332
            },
            "offsets": [
                "-10"
            ]
        },
        {
            "id": "Pacific/Kanton",
            "aliases": [
                "Pacific/Enderbury"
            ],
            "location": {
                "countryCode": "KI",
                "countryName": "Kiribati",
                "comment": "Phoenix Islands",
                "latitude": -2.783333333333333,
                "longitude": -171.71666666666667
            },
            "offsets": [
                "\u002B13"
            ]
        },
        {
            "id": "Pacific/Kiritimati",
            "aliases": [],
            "location": {
                "countryCode": "KI",
                "countryName": "Kiribati",
                "comment": "Line Islands",
                "latitude": 1.8666666666666667,
                "longitude": -157.33333333333334
            },
            "offsets": [
                "\u002B14"
            ]
        },
        {
            "id": "Pacific/Kosrae",
            "aliases": [],
            "location": {
                "countryCode": "FM",
                "countryName": "Micronesia",
                "comment": "Kosrae",
                "latitude": 5.316666666666666,
                "longitude": 162.98333333333332
            },
            "offsets": [
                "\u002B11"
            ]
        },
        {
            "id": "Pacific/Kwajalein",
            "aliases": [
                "Kwajalein"
            ],
            "location": {
                "countryCode": "MH",
                "countryName": "Marshall Islands",
                "comment": "Kwajalein",
                "latitude": 9.083333333333334,
                "longitude": 167.33333333333334
            },
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "Pacific/Majuro",
            "aliases": [],
            "location": {
                "countryCode": "MH",
                "countryName": "Marshall Islands",
                "comment": "Marshall Islands (most areas)",
                "latitude": 7.15,
                "longitude": 171.2
            },
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "Pacific/Marquesas",
            "aliases": [],
            "location": {
                "countryCode": "PF",
                "countryName": "French Polynesia",
                "comment": "Marquesas Islands",
                "latitude": -9,
                "longitude": -139.5
            },
            "offsets": [
                "-09:30"
            ]
        },
        {
            "id": "Pacific/Nauru",
            "aliases": [],
            "location": {
                "countryCode": "NR",
                "countryName": "Nauru",
                "comment": "",
                "latitude": -0.5166666666666667,
                "longitude": 166.91666666666666
            },
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "Pacific/Niue",
            "aliases": [],
            "location": {
                "countryCode": "NU",
                "countryName": "Niue",
                "comment": "",
                "latitude": -19.016666666666666,
                "longitude": -169.91666666666666
            },
            "offsets": [
                "-11"
            ]
        },
        {
            "id": "Pacific/Norfolk",
            "aliases": [],
            "location": {
                "countryCode": "NF",
                "countryName": "Norfolk Island",
                "comment": "",
                "latitude": -29.05,
                "longitude": 167.96666666666667
            },
            "offsets": [
                "\u002B11",
                "\u002B11:30",
                "\u002B12"
            ]
        },
        {
            "id": "Pacific/Noumea",
            "aliases": [],
            "location": {
                "countryCode": "NC",
                "countryName": "New Caledonia",
                "comment": "",
                "latitude": -22.266666666666666,
                "longitude": 166.45
            },
            "offsets": [
                "\u002B11"
            ]
        },
        {
            "id": "Pacific/Pago_Pago",
            "aliases": [
                "Pacific/Midway",
                "Pacific/Samoa",
                "US/Samoa"
            ],
            "location": {
                "countryCode": "AS",
                "countryName": "Samoa (American)",
                "comment": "",
                "latitude": -14.266666666666667,
                "longitude": -170.7
            },
            "offsets": [
                "-11"
            ]
        },
        {
            "id": "Pacific/Palau",
            "aliases": [],
            "location": {
                "countryCode": "PW",
                "countryName": "Palau",
                "comment": "",
                "latitude": 7.333333333333333,
                "longitude": 134.48333333333332
            },
            "offsets": [
                "\u002B09"
            ]
        },
        {
            "id": "Pacific/Pitcairn",
            "aliases": [],
            "location": {
                "countryCode": "PN",
                "countryName": "Pitcairn",
                "comment": "",
                "latitude": -25.066666666666666,
                "longitude": -130.08333333333334
            },
            "offsets": [
                "-08"
            ]
        },
        {
            "id": "Pacific/Pohnpei",
            "aliases": [
                "Pacific/Ponape"
            ],
            "location": {
                "countryCode": "FM",
                "countryName": "Micronesia",
                "comment": "Pohnpei/Ponape",
                "latitude": 6.966666666666667,
                "longitude": 158.21666666666667
            },
            "offsets": [
                "\u002B11"
            ]
        },
        {
            "id": "Pacific/Port_Moresby",
            "aliases": [
                "Antarctica/DumontDUrville"
            ],
            "location": {
                "countryCode": "PG",
                "countryName": "Papua New Guinea",
                "comment": "Papua New Guinea (most areas)",
                "latitude": -9.5,
                "longitude": 147.16666666666666
            },
            "offsets": [
                "\u002B10"
            ]
        },
        {
            "id": "Pacific/Rarotonga",
            "aliases": [],
            "location": {
                "countryCode": "CK",
                "countryName": "Cook Islands",
                "comment": "",
                "latitude": -21.233333333333334,
                "longitude": -159.76666666666668
            },
            "offsets": [
                "-10"
            ]
        },
        {
            "id": "Pacific/Tahiti",
            "aliases": [],
            "location": {
                "countryCode": "PF",
                "countryName": "French Polynesia",
                "comment": "Society Islands",
                "latitude": -17.533333333333335,
                "longitude": -149.56666666666666
            },
            "offsets": [
                "-10"
            ]
        },
        {
            "id": "Pacific/Tarawa",
            "aliases": [],
            "location": {
                "countryCode": "KI",
                "countryName": "Kiribati",
                "comment": "Gilbert Islands",
                "latitude": 1.4166666666666667,
                "longitude": 173
            },
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "Pacific/Tongatapu",
            "aliases": [],
            "location": {
                "countryCode": "TO",
                "countryName": "Tonga",
                "comment": "",
                "latitude": -21.133333333333333,
                "longitude": -175.2
            },
            "offsets": [
                "\u002B13",
                "\u002B14"
            ]
        },
        {
            "id": "Pacific/Wake",
            "aliases": [],
            "location": {
                "countryCode": "UM",
                "countryName": "US minor outlying islands",
                "comment": "Wake Island",
                "latitude": 19.283333333333335,
                "longitude": 166.61666666666667
            },
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "Pacific/Wallis",
            "aliases": [],
            "location": {
                "countryCode": "WF",
                "countryName": "Wallis \u0026 Futuna",
                "comment": "",
                "latitude": -13.3,
                "longitude": -176.16666666666666
            },
            "offsets": [
                "\u002B12"
            ]
        },
        {
            "id": "PST8PDT",
            "aliases": [],
            "location": null,
            "offsets": [
                "-08",
                "-07"
            ]
        },
        {
            "id": "WET",
            "aliases": [],
            "location": null,
            "offsets": [
                "\u002B00",
                "\u002B01"
            ]
        }
    ]
}

export const IanaTimezones = ianaTimezones;